import { createFileRoute } from "@tanstack/react-router";
import { RoutedDashboardPage } from "../../dashboard-page-context";
import { requireRoutePermission } from "../../route-authorization";

export const Route = createFileRoute("/app/kpis")({
  beforeLoad: () => requireRoutePermission("reporting.overview.view"),
  component: RoutedDashboardPage,
});
